import { forgotPassword } from 'APIs/identity';
import Spinner from 'Components/Spinner/Spinner';
import { ReactComponent as LogoIcon } from 'assets/svg/april-logo.svg';
import { ReactComponent as EmailIcon } from 'assets/svg/email.svg';
import React, { ChangeEvent, FormEvent, useState } from 'react';
import validateEmail from 'utils/validateEmail';

import * as s from './styles';

const GlobalForgetPwd = () => {
  const [email, setEmail] = useState<string>('');
  const [hasError, setHasError] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isValidEmail, setIsValidEmail] = useState<boolean>(true);
  const [message, setMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [supportEmail] = useState<string>('support@meetapril.com');

  const handleChangeEmail = (e: ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;
    setEmail(value);
    setIsValidEmail(validateEmail(value));
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const fPResp = await forgotPassword({
        email,
      });
      if (!fPResp.success) {
        throw Error(`Request failed: ${fPResp.error?.message ?? 'Unknown error'}`);
      }
      setIsSuccess(true);
      setMessage('Reset password link sent, please check your inbox.');
    } catch (error) {
      setHasError(true);
      setMessage(error?.message || 'Failed to reset password');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <s.Wrapper>
      <s.Header>
        <s.Nav>
          <s.LogoWrapper>
            <LogoIcon className="logo" />
          </s.LogoWrapper>
        </s.Nav>
      </s.Header>
      <s.Content>
        <s.ResetPwdForm onSubmit={handleSubmit}>
          <s.FormHeader className="form-header">
            <s.FormTitle>Forgot your password?</s.FormTitle>
            <s.FormDescription>Please click the button below to request a reset password link.</s.FormDescription>
            {(hasError || isSuccess) && <s.MessageBar hasError={hasError}>{message}</s.MessageBar>}
          </s.FormHeader>
          <s.InputWrapper>
            <s.Label htmlFor="email">
              <s.IconWrapper>
                <EmailIcon className="email-icon" />
              </s.IconWrapper>
              <s.Input
                type="email"
                id="email"
                name="email"
                autoFocus
                value={email}
                placeholder="EMAIL ADDRESS"
                onChange={handleChangeEmail}
                autoComplete="username"
              />
            </s.Label>
          </s.InputWrapper>
          <s.InputSubmit>
            <s.Small>
              <s.HelpLink href={`mailto:${supportEmail}`} tabIndex={-1}>
                Need help? Contact us
              </s.HelpLink>
              <s.SubmitBtn type="submit" disabled={isLoading || email.length === 0 || !isValidEmail}>
                Request a reset password link
                {isLoading && (
                  <s.SpinnerWrapper>
                    <Spinner width="30px" height="30px" borderWidth="3px" />
                  </s.SpinnerWrapper>
                )}
              </s.SubmitBtn>
            </s.Small>
          </s.InputSubmit>
        </s.ResetPwdForm>
      </s.Content>
    </s.Wrapper>
  );
};

export default GlobalForgetPwd;
